import axios from "axios";
import { API_BASE_URL, API_KEY } from "../config";

// Create Axios instance
const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    "Strict-Transport-Security": "max-age=31536000; includeSubDomains; preload",
    "x-api-key": API_KEY, // Example: Adding API Key globally
  },
});

// 🔹 Request Interceptor: Runs before every request
axiosInstance.interceptors.request.use(
  async (config) => {
    const token = sessionStorage.getItem("accessToken");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 🔹 Response Interceptor: Runs after every response
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("API Error:", error);
    if (error.response?.status === 401) {
      sessionStorage.removeItem("accessToken"); // clear token
      window.location.href = "/login"; // force redirect
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
